import configData from "../../../Config/CustomStyle.json";

export const normalizeBlanks = (text) => {
  if (typeof text !== "string") return text;
  return text
    .replace(/\(\s*[-_ \t]*[-_]+[-_ \t]*\)/g, "(_)")
    .replace(/_{2,}/g, "(_)")
    .replace(/-{2,}/g, "(_)");
};


export const getOriginalBotMsg = (messages) => {
  if (!messages) return null;
  return (
    messages
      .slice()
      .reverse()
      .find(
        (m) =>
          m.sender === "bot" &&
          (m.isLesson === true ||
            (m.text && m.text.includes("lesson-questions-data"))),
      ) || messages.find((m) => m.sender === "bot")
  );
};

export const getRelativeLinks = (messages) => {
  if (!messages) return [];
  const originalBotMsg = getOriginalBotMsg(messages);
  if (!originalBotMsg) return [];

  // First, try to read from the parsed relativeLessons property
  if (originalBotMsg.relativeLessons && Array.isArray(originalBotMsg.relativeLessons) && originalBotMsg.relativeLessons.length > 0) {
    const parsedLinks = originalBotMsg.relativeLessons.map((lesson) => {
      let href = lesson.Link || lesson.Url || lesson.href || lesson.link || "";
      if (!href) {
        const type = lesson.Type || lesson.type || "";
        if (type === "File") {
          href = lesson.FileUrl || lesson.fileUrl || "#";
        } else {
          const urlPrefix = type === "Game" ? "GameView" : (type === "Exam" ? "ExamView" : "LessonView");
          href = `/${urlPrefix}/${lesson.Id || lesson.id}`;
        }
      }
      const text = lesson.Name || lesson.Text || lesson.text || lesson.name || "عرض الدرس";
      return {
        href,
        text,
        style: lesson.style || "",
        icon: lesson.Icon || lesson.icon || "",
        indexId: lesson.IndexId || lesson.indexId || null,
        indexPath: lesson.IndexPath || lesson.indexPath || "",
        type: lesson.Type || lesson.type || ""
      };
    }).filter((lesson) => lesson.href);

    if (parsedLinks.length > 0) {
      return parsedLinks;
    }
  }

  // Fallback: parse from the HTML text
  const parser = new DOMParser();
  const doc = parser.parseFromString(originalBotMsg.text, "text/html");
  const links = doc.querySelectorAll("a");
  const relativeLinks = [];
  links.forEach((link) => {
    const href = link.getAttribute("href");
    if (
      href &&
      (href.includes("LessonView") ||
        href.includes("GameView") ||
        href.includes("ExamView") ||
        href.includes("alarabeyya.com") ||
        href.includes("/File/"))
    ) {
      relativeLinks.push({
        href: href,
        text: link.textContent || link.innerText || "عرض الدرس",
        style: link.getAttribute("style") || "",
        icon: "",
        indexId: null,
        indexPath: "",
        type: href.includes("/File/") ? "File" : (href.includes("GameView") ? "Game" : (href.includes("ExamView") ? "Exam" : "Lesson"))
      });
    }
  });
  return relativeLinks;
};

export const safeParseJSON = (str) => {
  if (!str) return null;
  let cleaned = str.trim();

  // 1. Decode HTML entities if present
  if (cleaned.includes("&")) {
    try {
      const txt = document.createElement("textarea");
      txt.innerHTML = cleaned;
      cleaned = txt.value;
    } catch (e) {}
  }

  // 2. Try parsing directly
  try {
    return JSON.parse(cleaned);
  } catch (e) {}

  // 3. Clean up common JSON issues:
  try {
    // Replace trailing commas before closing brackets/braces
    cleaned = cleaned.replace(/,\s*([\]}])/g, "$1");

    // Escape raw unescaped newlines/control characters inside double-quoted strings
    let inString = false;
    let newStr = "";
    for (let i = 0; i < cleaned.length; i++) {
      const char = cleaned[i];
      if (char === '"' && (i === 0 || cleaned[i - 1] !== "\\")) {
        inString = !inString;
        newStr += char;
      } else if (inString && (char === "\n" || char === "\r")) {
        newStr += char === "\n" ? "\\n" : "\\r";
      } else {
        newStr += char;
      }
    }
    cleaned = newStr;

    return JSON.parse(cleaned);
  } catch (err) {
    return null;
  }
};

export const extractQuestionsCount = (text) => {
  if (!text) return 0;
  const match = text.match(
    /<script\s+id=['"]lesson-questions-data['"]\s+type=['"]application\/json['"]>([\s\S]*?)<\/script>/i,
  );
  if (match && match[1]) {
    const parsed = safeParseJSON(match[1]);
    if (Array.isArray(parsed)) {
      return parsed.length;
    }
  }
  return 0;
};

export const cleanBotHtml = (html) => {
  if (!html) return "";
  const match = html.match(/<script\s+id=['"]lesson-questions-data['"]/i);
  if (match && match.index !== undefined) {
    return html.substring(0, match.index).trim().replace(/\*\*([\s\S]*?)\*\*/g, '<b>$1</b>');
  }
  return html
    .replace(
      /<script\s+id=['"]lesson-questions-data['"]\s+type=['"]application\/json['"]>[\s\S]*?<\/script>/gi,
      "",
    )
    .trim()
    .replace(/\*\*([\s\S]*?)\*\*/g, '<b>$1</b>');
};

export const calculateExpectedTime = (messages) => {
  if (!messages) return 0;
  const originalBotMsg = getOriginalBotMsg(messages);
  if (!originalBotMsg) return 0;
  const lessonHtml = cleanBotHtml(originalBotMsg.text);
  const textOnly = lessonHtml.replace(/<[^>]*>/g, " ");
  const words = textOnly.trim().split(/\s+/).filter(Boolean);
  const wordCount = words.length;
  const questionsCount = extractQuestionsCount(originalBotMsg.text);
  const readTime = wordCount / 120; // 120 WPM for student reading time speed
  const solveTime = questionsCount * 1.5;
  return Math.ceil(readTime + solveTime);
};

export const getMergedCustomStyle = (q) => {
  const defaultStyle = configData.CustomStyle;
  const qStyle = q.CustomStyle || {};
  return {
    ...defaultStyle,
    ...qStyle,
    questionStyle: {
      ...defaultStyle.questionStyle,
      ...(qStyle.questionStyle || {}),
    },
    questionTypeStyle: {
      ...defaultStyle.questionTypeStyle,
      AnswersSelectType:
        q.Answers && q.Answers.filter((a) => a.True === 1).length > 1
          ? "checkbox"
          : "radio",
      ...(qStyle.questionTypeStyle || {}),
    },
    answerStyle: {
      ...defaultStyle.answerStyle,
      ...(qStyle.answerStyle || {}),
    },
    answerBoxStyle: {
      ...defaultStyle.answerBoxStyle,
      ...(qStyle.answerBoxStyle || {}),
    },
    categoryStyle: {
      ...defaultStyle.categoryStyle,
      ...(qStyle.categoryStyle || {}),
    },
    categoryHoverStyle: {
      ...defaultStyle.categoryHoverStyle,
      ...(qStyle.categoryHoverStyle || {}),
    },
    categoryListStyle: {
      ...defaultStyle.categoryListStyle,
      ...(qStyle.categoryListStyle || {}),
    },
    buttonHoverStyle: {
      ...defaultStyle.buttonHoverStyle,
      ...(qStyle.buttonHoverStyle || {}),
    },
    buttonStyle: {
      ...defaultStyle.buttonStyle,
      ...(qStyle.buttonStyle || {}),
    },
    questionSound: {
      Confetti: "random",
      TrueSound: "random",
      FalseSound: "random",
      ...(qStyle.questionSound || {}),
    },
    gamesSetting: {
      ...defaultStyle.gamesSetting,
      ...(qStyle.gamesSetting || {}),
    },
  };
};

export const extractQuestionsFromMessage = (text) => {
  if (!text) return null;
  const match = text.match(
    /<script\s+id=['"]lesson-questions-data['"]\s+type=['"]application\/json['"]>([\s\S]*?)<\/script>/i,
  );
  if (match && match[1]) {
    const parsed = safeParseJSON(match[1]);
    if (Array.isArray(parsed) && parsed.length > 0) {
      return parsed.map((q) => ({
        ...q,
        CustomStyle: getMergedCustomStyle(q),
      }));
    }
  }
  return null;
};

export const convertNonDbQuestion = (q) => {
  let typeId = 1;
  let typeName = "اختيار من متعدد";

  const typeVal = q.type || q.Type;
  let tStr = "";

  if (typeVal) {
    if (typeof typeVal === "object") {
      const idVal = typeVal.Id !== undefined ? typeVal.Id : typeVal.id;
      if (idVal !== undefined) {
        typeId = Number(idVal) || 1;
      }
      typeName = typeVal.Name || typeVal.name || typeName;
      
      const nameVal = typeVal.Name || typeVal.name || "";
      tStr = String(nameVal).toLowerCase();
    } else {
      tStr = String(typeVal).toLowerCase();
    }
  }

  if (tStr === "selectoption" || tStr === "1") {
    typeId = 1;
    typeName = "اختيار من متعدد";
  } else if (tStr === "selectmultiple" || tStr === "7") {
    typeId = 7;
    typeName = "اختيار من متعدد (إجابات متعددة)";
  } else if (tStr === "dragdrop" || tStr === "3") {
    typeId = 3;
    typeName = "سحب وإسقاط";
  } else if (tStr === "fillblank" || tStr === "4") {
    typeId = 4;
    typeName = "ملء الفراغات";
  } else if (tStr === "selectlist" || tStr === "6") {
    typeId = 6;
    typeName = "تحديد من القائمة";
  }

  let answers = [];
  if (typeId === 1 || typeId === 7) {
    const rawOptions = q.options || q.Options || [];
    const options = Array.isArray(rawOptions) ? rawOptions : [];
    const rawCorrectAnswers = q.correctAnswers || q.CorrectAnswers || [];
    const correctAnswers = Array.isArray(rawCorrectAnswers) ? rawCorrectAnswers : [rawCorrectAnswers];
    
    answers = options.map((opt, idx) => {
      const optIndex = opt.index !== undefined ? opt.index : (opt.Id !== undefined ? opt.Id : idx + 1);
      const optText = typeof opt === "object" ? (opt.text || opt.name || "") : opt;
      const isCorrect = correctAnswers.includes(optIndex);
      return {
        Id: optIndex,
        Name: optText,
        True: isCorrect ? 1 : 0,
        Sort: optIndex,
        CustomStyle: null,
      };
    });
  } else {
    const rawAnswers = q.answers || q.Answers || [];
    const answersList = Array.isArray(rawAnswers) ? rawAnswers : [];
    
    answers = answersList.map((ans, idx) => {
      const ansIndex = ans.index !== undefined ? ans.index : (ans.Id !== undefined ? ans.Id : idx + 1);
      const ansText = typeof ans === "object" ? (ans.text || ans.name || "") : ans;
      return {
        Id: ansIndex,
        Name: ansText,
        Sort: ansIndex,
      };
    });
  }

  const rawCategories = q.categories || q.Categories || [];
  const categoriesList = Array.isArray(rawCategories) ? rawCategories : [];
  const categories = categoriesList.map((cat, idx) => {
    const catIndex = cat.index !== undefined ? cat.index : (cat.Id !== undefined ? cat.Id : idx + 1);
    const catText = typeof cat === "object" ? (cat.text || cat.name || "") : cat;
    return {
      Id: catIndex,
      Name: normalizeBlanks(catText),
      Sort: catIndex,
      CustomStyle: null,
    };
  });

  const rawMapping = q.correctMapping || q.CorrectMapping || [];
  const mappingList = Array.isArray(rawMapping) ? rawMapping : [];
  const fills = mappingList.map((map, idx) => {
    return {
      Id: idx + 1,
      CategoryId: map.categoryIndex !== undefined ? map.categoryIndex : map.CategoryId,
      AnswerId: map.correctAnswerIndex !== undefined ? map.correctAnswerIndex : map.AnswerId,
      Sort: map.fillInBlankIndex !== undefined ? map.fillInBlankIndex : map.Sort,
    };
  });

  const safeId = q.Id !== undefined && q.Id !== null ? q.Id : (q.id !== undefined && q.id !== null ? q.id : "");

  return {
    ...q,
    Id: String(safeId),
    lessonId: q.lessonId || q.LessonId || "",
    LessonId: q.lessonId || q.LessonId || "",
    isFromDB: false,
    IsDbQuestion: false,
    Name: normalizeBlanks(q.questionText || q.QuestionText || ""),
    Mark: 2.0,
    Type: {
      Id: typeId,
      Name: typeName,
    },
    CustomStyle: getMergedCustomStyle(q),
    SolveKey: null,
    Answers: answers.length > 0 ? answers : null,
    Fills: fills.length > 0 ? fills : null,
    Categories: categories.length > 0 ? categories : null,
    Matches: null,
  };
};
